import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlConsultaDiarias = '/service/contabilidade/transparencia/adiantametos/'

class ConsultaAdiantamentosSuprimentosService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
        const adms = config.adms && config.adms.length > 0 ? config.adms.join() : null
        this.state = {
            adms: adms,
        }
    }

    consultar(filtro) {
        let data = {
            exercicio: filtro.exercicio ? filtro.exercicio.value : '',
            administracao: filtro.administracao ? filtro.administracao.map(e => e.value).join() : this.state.adms,
            periodoUtilizacaoInicial: filtro.periodoUtilizacaoInicial ? filtro.periodoUtilizacaoInicial : '',
            periodoUtilizacaoFinal: filtro.periodoUtilizacaoFinal ? filtro.periodoUtilizacaoFinal : '',
            nomeFavorecido: filtro.nome ? filtro.nome : null,
            documentoFavorecido: filtro.documento ? filtro.documento : null,
        }

        return this.conex.post(urlConsultaDiarias + 'adiantametosSuprimentos/', JSON.stringify(data))
    }
}

export default ConsultaAdiantamentosSuprimentosService
